/* eslint-disable no-unused-vars */
import * as React from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import dayjs from "dayjs";
import RegistrationForm from "../components/RequestEdit/RegistrationForm";
import RequiredDocument from "../components/RequestEdit/RequiredDocument";
import ApprovalStatus from "../components/RequestEdit/ApprovalStatus";
import { RequestFormAPI, SharePointFolder } from "../services/apigateway";
import helper from "../services/helper";
import "../styles/RequestEdit.css";

export default function RequestEditScreen() {
  const navigate = useNavigate();

  const { id, tab } = useParams();
  const [lastModifiedDate, setLastModifiedDate] = React.useState();
  const [requestNumber, setRequestNumber] = React.useState();
  const [activeTab, setActiveTab] = React.useState("RegistrationForm");
  const [dataSaving, setDataSaving] = React.useState(false);
  const [dataLoading, setDataLoading] = React.useState(false);
  const [uploadFileOther, setUploadFileOther] = React.useState([]);
  const [pathsSharePoint, setPathsSharePoint] = React.useState([]);

  const [objRegistrationForm, setObjRegistrationForm] = React.useState({
    RequestFormHeaderId: "",
    RequestFormItemId: "",
    CustomerId: "",
    CompanyNameLocal: "",
    CompanyNameEN: "",
    CompanyNameFormer: "",
    CompanyNameLanguage: "",
    CompanyNameAlias: "",
    CustomerType: "",
    SupplierType: "",
    BusinessType: "",
    BusinessTypeOthers: "",
    LegalEntityType: "",
    LegalEntityTypeOthers: "",
    IncorporationDate: "",
    TAXNumber: "",
    Website: "",
    HouseNo: "",
    Building: "",
    Room: "",
    Floor: "",
    Street: "",
    District: "",
    SubDistrict: "",
    City: "a0L1m000004GpMOEA0",
    Country: "a0L1m000004GmiSEAS",
    PostalCode: "",
    LocationURL: "",
    Latitude: "",
    Longitude: "",
    MailingIsSameAsRegistered: false,
    MailingHouseNo: "",
    MailingBuilding: "",
    MailingRoom: "",
    MailingFloor: "",
    MailingStreet: "",
    MailingSubDistrict: "",
    MailingDistrict: "",
    MailingCity: "a0L1m000004GpMOEA0",
    MailingCountry: "a0L1m000004GmiSEAS",
    MailingPostalCode: "",
    ContactId: "",
    ContactSalutation: "",
    ContactNickName: "",
    ContactFirstName: "",
    ContactLastName: "",
    ContactPosition: "",
    ContactEmail: "",
    ContactMobileCountryCode: "TH",
    ContactMobileNumber: "",
    ContactPhoneCountryCode: "TH",
    ContactPhoneNumber: "",
    ContactFaxCountryCode: "TH",
    ContactFaxNumber: "",
    InterestedPetroleumAsCustomer: false,
    InterestedPetrochemicalAsCustomer: false,
    InterestedLubeBaseAsCustomer: false,
    InterestedLABIXAsCustomer: false,
    InterestedCrudeAsCustomer: false,
    InterestedLubeBaseAsCustomerDesc: "",
    InterestedLABIXAsCustomerDesc: "",
    InterestedCrudeAsSupplier: false,
    InterestedB100EthanolAsSupplier: false,
    InterestedPetroleumAndComponentAsSupplier: false,
    InterestedPetroleumAndComponentAsSupplierDesc: "",
    InterestedLongResidueAsSupplier: false,
    InterestedNormalParaffinAsSupplier: false,
    InterestedOtherAsCustomer: false,
    InterestedOtherAsCustomerDesc: "",
    InterestedOtherAsSupplier: false,
    InterestedOtherAsSupplierDesc: "",
    MinistryOfEnergyRegistrationNo: "",
    YearsOfExperience: 0,
    EstimatedMonthlyPurchaseQuantity: 0,
    EstimatedMonthlyPurchaseUnit: "",
    StartTradingDate: dayjs(),
    DestinationCountries: [
      {
        Id: "",
        Country: "TH - Thailand",
        LocationType: "Local",
      },
    ],
    PurchaseProductFromCompany: "",
    SupplyProductToCompany: "",
    PaymentOverTheAmountOfUSD: "Yes",
    ReasonOfPaymentOverTheAmountOfUSD: "",
    FailedSupplyAgreement: "",
    ReasonOfFailedSupplyAgreement: "",
    HaveTagetsInSanction: "",
    ReasonOfHaveTagetsInSanction: "",
    ViolatingAntiMoneyLaunderingLaws: "No",
    ReasonOfViolatingAntiMoneyLaunderingLaws: "",
    OwnStorageAsCustomer: false,
    RentStorageMoreThanOneYearAsCustomer: false,
    RentStorageLessThanOneYearAsCustomer: false,
    NoStorageAsCustomer: false,
    OwnTransportAsCustomer: false,
    RentTransportMoreThanOneYearAsCustomer: false,
    RentTransportLessThanOneYearAsCustomer: false,
    NoTransportAsCustomer: false,
    OwnStorageAsSupplier: false,
    RentStorageMoreThanOneYearAsSupplier: false,
    RentStorageLessThanOneYearAsSupplier: false,
    NoStorageAsSupplier: false,
    OwnTransportAsSupplier: false,
    RentTransportMoreThanOneYearAsSupplier: false,
    RentTransportLessThanOneYearAsSupplier: false,
    NoTransportAsSupplier: false,
    EnvironmentPolicy: "Yes",
    OccupationalHealthAndSafetyPolicy: "Yes",
    CorporateGovernancePolicy: "Yes",
    HumanRightsPolicy: "Yes",
  });

  React.useEffect(() => {
    if (id) masterDataRegistrationForm(id);
  }, [id]);

  const masterDataRegistrationForm = async (id) => {
    setDataLoading(true);
    const data = await RequestFormAPI.getById(id);
    setObjRegistrationForm(data);
    setDataLoading(false);

    setLastModifiedDate(
      dayjs(data.RequestItems[0].LastModifiedDate).format("DD/MM/YYYY HH:mm")
    );
    setRequestNumber(data.RequestItems[0].Name);
  };

  React.useEffect(() => {
    // Call your RequestForm function here
    const fetchData = async () => {
      try {
        const userInfo = helper.Auth.getTokenData();
        if (userInfo.accounts[0]) {
          const response = await SharePointFolder.getPathByAccount(
            userInfo.accounts[0].Id
          );
          const filesSharePoint = response.responseData;

          const fin = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_Financial"
          );
          const coi = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_COI"
          );
          const moa = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_MOA"
          );
          const shr = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_List_Sharehold"
          );
          const vat = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_VAT_Reg"
          );
          const moe = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_Reg_by_MoE"
          );
          const oth = filesSharePoint.find(
            (item) => item.Name === "Account_Common_CTR_Others"
          );

          setPathsSharePoint({
            Account_Common_CTR_Financial: fin.Path || "",
            Account_Common_CTR_COI: coi.Path || "",
            Account_Common_CTR_MOA: moa.Path || "",
            Account_Common_CTR_List_Sharehold: shr.Path || "",
            Account_Common_CTR_VAT_Reg: vat.Path || "",
            Account_Common_CTR_Reg_by_MoE: moe.Path || "",
            Account_Common_CTR_Others: oth.Path || "",
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const uploadFile = async (folder, file) => {
    try {
      const uploadResponse = await SharePointFolder.uploadFile(folder, [file]);
      console.log("Upload response:", uploadResponse);

      // Check if upload failed
      if (!uploadResponse || uploadResponse.error || uploadResponse.message === 'error' || uploadResponse.message === 'Upload failed') {
        Swal.fire({
          title: "Upload Failed",
          text: "Upload failed. Please try again or contact your administrator.",
          icon: "error",
          position: "center", showConfirmButton: true,
        }).then((res) => {
          if (res.isConfirmed) {
            window.location.reload();
          }
        });
        return false;
      }
      return true;
    } catch (error) {
      console.error("Error while uploading:", error);
      if (error.response) {
        console.error("Response:", error.response);
      }
      Swal.fire({
        title: "Upload Failed",
        text: "Upload failed. Please try again or contact your administrator.",
        icon: "error",
        position: "center",
        showConfirmButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          window.location.reload();
        }
      });
      return false;
    }
  };

  const updateFiles = async () => {
    try {
      const filesMap = {
        FinancialFirst: pathsSharePoint.Account_Common_CTR_Financial,
        FinancialSecond: pathsSharePoint.Account_Common_CTR_Financial,
        FinancialThird: pathsSharePoint.Account_Common_CTR_Financial,
        FileCOI: pathsSharePoint.Account_Common_CTR_COI,
        FileMOA: pathsSharePoint.Account_Common_CTR_MOA,
        FileVAT: pathsSharePoint.Account_Common_CTR_VAT_Reg,
        FileShareholder: pathsSharePoint.Account_Common_CTR_List_Sharehold,
        FileMoE: pathsSharePoint.Account_Common_CTR_Reg_by_MoE,
        FileOther: pathsSharePoint.Account_Common_CTR_Others,
      };

      const files = {};
      let allFilesSelected = true;

      for (const [id, folder] of Object.entries(filesMap)) {
        const fileInput = document.getElementById(id);
        if (fileInput && fileInput.files.length > 0) {
          files[id] = fileInput.files;
        } else {
          allFilesSelected = false;
        }
      }

      if (!allFilesSelected) {
        console.error("Please select all required files.");
        return;
      }

      // Uploading files
      for (const [id, fileList] of Object.entries(files)) {
        const folder = filesMap[id];
        if (id === "FileOther") {
          for (const file of fileList) {
            const uploadResult = await uploadFile(folder, file);

            // ถ้า upload ไม่สำเร็จ ให้หยุดทันที
            if (uploadResult === false) {
              throw new Error("Upload failed");
            }
          }
        } else {
          const uploadResult = await uploadFile(folder, fileList[0]);

          // ถ้า upload ไม่สำเร็จ ให้หยุดทันที
          if (uploadResult === false) {
            throw new Error("Upload failed");
          }
        }
      }

      // Resetting input values after successful upload
      for (const id in files) {
        document.getElementById(id).value = "";
      }
    } catch (error) {
      console.error("Error in handling file upload:", error);
      throw error; // Re-throw เพื่อให้ caller รู้ว่ามี error
    }
  };

  const updateRequestFormByIds = async (data) => {
    const dataUpdate = data;
    Swal.fire({
      title: "Are you sure you want to save?",
      icon: "question",
      position: "center",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Yes",
      cancelButtonColor: "red",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setDataSaving(true);
        await RequestFormAPI.updateRequestForm(dataUpdate);
        await updateFiles();
        setDataSaving(false);
        Swal.fire({
          title: "Saved!",
          icon: "success",
          showConfirmButton: false,
          timer: 1200,
        });
        navigate(`/request/view/${id}`);
      }
    });
  };

  const handleClickTab = (event) => {
    setActiveTab(event.currentTarget.dataset.tab);
  };

  return (
    <Container maxWidth="xl" className="RequestEditScreen">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={dataLoading || dataSaving}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* title header */}
      <div className="header">
        <div>
          <label>Request Number</label>
          <p>{requestNumber}</p>
        </div>
        <div>
          <label>Last Update Date</label>
          <p>{lastModifiedDate}</p>
        </div>
      </div>

      {/* status-bar */}
      <div className="path">
        <ApprovalStatus currentStatus={"Review"} />
      </div>

      {/* form-data */}
      <div style={{ display: "flex", marginTop: "10px" }}>
        {/* tab-side-left */}
        <div className="sidebar">
          <nav className="slds-nav-vertical" aria-label="Sub page">
            <div className="slds-nav-vertical__section">
              <ul aria-describedby="entity-header">
                <li
                  className={
                    activeTab === "RegistrationForm"
                      ? "slds-nav-vertical__item slds-is-active"
                      : "slds-nav-vertical__item"
                  }
                  onClick={handleClickTab}
                  data-tab="RegistrationForm"
                >
                  <span className="slds-nav-vertical__action">
                    Registration Form
                  </span>
                </li>
                <li
                  className={
                    activeTab === "RequiredDocuments"
                      ? "slds-nav-vertical__item slds-is-active"
                      : "slds-nav-vertical__item"
                  }
                  onClick={handleClickTab}
                  data-tab="RequiredDocuments"
                >
                  <span className="slds-nav-vertical__action">
                    Required Documents
                  </span>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        {/* form-body */}
        {!dataLoading && (
          <div style={{ background: "white", flexGrow: 1 }}>
            <Stack sx={{ width: "100%" }} spacing={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  disabled
                  variant="outlined"
                  onClick={() => navigate(`/request/edit/${id}/${tab}`)}
                >
                  Edit
                </Button>
              </Box>
              {activeTab === "RegistrationForm" && (
                <RegistrationForm
                  onFormDataObjectChange={(data) =>
                    setObjRegistrationForm(data)
                  }
                  formDataObject={objRegistrationForm}
                  // formDataDraft={(data) => updateRequestFormByIds(data)}
                  formId={id}
                />
              )}
              {activeTab === "RequiredDocuments" && (
                <RequiredDocument
                  onUploadFileOtherChange={(fileList) =>
                    setUploadFileOther(fileList)
                  }
                  onFormDataObjectChange={(data) =>
                    setObjRegistrationForm(data)
                  }
                  formDataObject={objRegistrationForm}
                  // formDataDraft={(data) => updateRequestFormByIds(data)}
                  formId={id}
                />
              )}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  sx={{ p: 1, m: 1 }}
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    Swal.fire({
                      title: "Do you want to leave this page?",
                      icon: "question",
                      position: "center",
                      showDenyButton: true,
                      showCancelButton: false,
                      confirmButtonText: "Yes",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        navigate(`/request/view/${id}`);
                      }
                    });
                  }}
                >
                  Cancel
                </Button>
                <Button
                  sx={{ p: 1, m: 1 }}
                  variant="outlined"
                  onClick={() => {
                    objRegistrationForm.Documents.Others.push(
                      ...uploadFileOther
                    );
                    updateRequestFormByIds(objRegistrationForm);
                  }}
                >
                  Save
                </Button>
              </Box>
            </Stack>
          </div>
        )}
      </div>
    </Container>
  );
}
